import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faDownload, faTrash } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../shared/components/Title";
import DropzoneComponent from "../../../shared/components/DropzoneComponent";

const SCOPE_NOTES = [
  "Auto-detection supports TGE, StarTrack and TNT, with manual override per file.",
  "TGE uses Consignments as source and ARCs as hit overrides.",
  "TGE Exclusions are ignored in the current flow.",
  "StarTrack uses Stop the Clock Date and Sp Expected Delivery Date.",
  "TNT sends exceptions only — any consignment not listed was delivered on time.",
  "TNT Client and Other exception categories convert to a hit; TNT-attributable ones stay a miss.",
  "A TNT row with no Actual Delivery keeps the existing Machship date.",
];

const ACTION_BUTTON =
  "flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50";

export default function UploadHeaderCard({
  dropzone,
  isProcessing,
  isSaving,
  uploadedCount,
  processedRecordCount,
  onSave,
  onExport,
  onClear,
}) {
  return (
    <div className="rounded-[28px] bg-gradient-to-br from-[#13395f] via-[#1d5c8f] to-[#f05d5e] p-[1px] shadow-xl">
      <div className="rounded-[27px] bg-white px-5 py-6 sm:px-8">
        <Title title="Carrier DIFOT Integration" />

        <div className="mt-4 grid gap-5 md:grid-cols-[1.4fr_0.6fr]">
          <div>
            <p className="text-sm leading-relaxed text-slate-600">
              Upload a TGE, StarTrack, or TNT workbook, then run processing from the
              backend DIFOT API. The automation output is used to review cleaned DIFOT
              data before it feeds reconciled ETA, completed date, and KPI explanation.
            </p>
            <div className="mt-5">
              <DropzoneComponent
                getRootProps={dropzone.getRootProps}
                getInputProps={dropzone.getInputProps}
                isDragActive={dropzone.isDragActive}
                fileTypes="carrier Excel"
              />
            </div>
          </div>

          <div className="rounded-3xl border border-blue-100 bg-gradient-to-br from-blue-50/60 to-slate-50 p-5">
            <div className="flex items-start gap-3">
              <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#144677] text-white text-sm">
                <FontAwesomeIcon icon={faCircleInfo} />
              </div>
              <div>
                <h2 className="text-sm font-semibold text-slate-900">Current Scope</h2>
                <ul className="mt-2 space-y-2 text-xs leading-5 text-slate-600">
                  {SCOPE_NOTES.map((note) => (
                    <li key={note} className="flex items-start gap-2">
                      <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#144677]/40" />
                      {note}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2.5">
          <button
            type="button"
            onClick={onSave}
            disabled={isProcessing || isSaving || uploadedCount === 0}
            className={`${ACTION_BUTTON} bg-emerald-600 text-white shadow-sm hover:bg-emerald-700`}
          >
            <FontAwesomeIcon icon={faDownload} />
            Save to Snowflake
          </button>
          <button
            type="button"
            onClick={onExport}
            disabled={processedRecordCount === 0}
            className={`${ACTION_BUTTON} border border-slate-300 bg-white text-slate-700 hover:border-slate-400 hover:bg-slate-50`}
          >
            <FontAwesomeIcon icon={faDownload} />
            Export Cleaned Output
          </button>
          <button
            type="button"
            onClick={onClear}
            disabled={uploadedCount === 0}
            className={`${ACTION_BUTTON} border border-red-200 bg-red-50 text-red-700 hover:bg-red-100`}
          >
            <FontAwesomeIcon icon={faTrash} />
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
}
